import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'admin-travel-detail-form',
  templateUrl: './travel-detail-form.component.html',
  styleUrls: ['./travel-detail-form.component.css','../admin.css']
})
export class AdminTravelDetailFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  triggerClick(id){
   (<HTMLInputElement>window.document.getElementById(id)).click()
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/travel-detail-form/travel-detail-form.component.ts